(function () {
  'use strict';

  angular
      .module('app')
      .factory('DashboardService', DashboardService);

  DashboardService.$inject = ['$http', '$q', 'WebAPIUrl'];

  function DashboardService($http, $q, WebAPIUrl) {

    var service = {
      getAvailableWidgets: getAvailableWidgets
    };


    return service;

    function getAvailableWidgets() {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        url: WebAPIUrl + '/api/Dashboard/AvailableWidgets',
        data: {}
      }).success(function (data, status, headers, cfg) {
        //console.log(data);
        deferred.resolve(data);
      }).error(function (err, status) {
        deferred.reject(err, status);
      });
      return deferred.promise;
    }
  }
})();